import React, { useState } from "react";
import { api } from "../../../lib/api";
import { toast } from "sonner";
import { UserPlus, X, Search } from "lucide-react";

export const PilotManager = ({ clients, onChange }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const search = async () => {
    if (q.trim().length < 3) return toast.error("Digite ao menos 3 caracteres");
    const { data } = await api.get(`/admin/payment-center/clients/search`, { params: { q } });
    setResults(data);
  };
  const act = async (id, add) => {
    try {
      const { data } = add ? await api.post(`/admin/payment-center/pilot/${id}`) : await api.delete(`/admin/payment-center/pilot/${id}`);
      onChange(data);
      toast.success(add ? "Cliente adicionada ao piloto" : "Cliente removida do piloto");
    } catch (e) { toast.error(e?.response?.data?.detail || "Falha"); }
  };
  return (
    <section className="border border-[#EBE5DF] bg-white p-6" data-testid="pc-pilot-section">
      <h2 className="text-lg font-semibold mb-1">Clientes piloto</h2>
      <p className="text-xs text-[#5C5A57] mb-4">No modo PILOT, só estas clientes veem a Central e geram PIX agrupado.</p>
      <div className="flex gap-2">
        <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()}
          placeholder="Buscar por nome ou CPF" className="flex-1 border border-[#EBE5DF] p-2 text-sm" data-testid="pc-pilot-search-input" />
        <button className="ghost" onClick={search} data-testid="pc-pilot-search-btn"><Search size={16} /></button>
      </div>
      {results.length > 0 && (
        <ul className="mt-3 divide-y divide-[#EBE5DF] border border-[#EBE5DF]" data-testid="pc-pilot-search-results">
          {results.map((c) => (
            <li key={c.id} className="flex items-center justify-between p-2 text-sm">
              <span>{c.name} <span className="text-[#5C5A57]">{c.cpf_masked}</span></span>
              <button className="ghost" onClick={() => act(c.id, true)} data-testid={`pc-pilot-add-${c.id}`}><UserPlus size={16} /></button>
            </li>
          ))}
        </ul>
      )}
      <ul className="mt-4 space-y-2" data-testid="pc-pilot-list">
        {clients.length === 0 && <li className="text-sm text-[#5C5A57]">Nenhuma cliente piloto.</li>}
        {clients.map((c) => (
          <li key={c.id} className="flex items-center justify-between bg-[#FBF8F5] px-3 py-2 text-sm" data-testid={`pc-pilot-item-${c.id}`}>
            <span>{c.name} <span className="text-[#5C5A57]">{c.cpf_masked}</span></span>
            <button className="ghost" onClick={() => act(c.id, false)} data-testid={`pc-pilot-remove-${c.id}`}><X size={16} /></button>
          </li>
        ))}
      </ul>
    </section>
  );
};
